// i18n area 'system' — locale cs-CZ (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.cs-CZ.meta.json.
import type { enUS } from './system'

export const csCZ: typeof enUS = {
  diagnostics: {
    title: 'Diagnostika',
    subtitle: 'Co je špatně, nejhorší napřed — stejná optika jako tvirt diagnose',
    reload: 'Znovu načíst',
    loadError: 'Diagnózu se nepodařilo přečíst',
    exportBundle: 'Exportovat balíček',
    exportError: 'Balíček se nepodařilo vytvořit',
    noProblem: 'V kontrolovaných oblastech žádný problém',
    nothingInspected: 'NIC nebylo zkontrolováno — to není potvrzení o dobrém zdraví',
    inspected: 'Zkontrolované',
    notInspected: 'NEZKONTROLOVANÉ',
    localHint: 'Lokální oblasti uzlu (jednotky systemd, journal) se čtou jen z CLI: tvirt diagnose --area local — cesta, když API neodpovídá.',
    thresholds: 'neúspěšné úlohy za {hours} h, heartbeat opožděný nad {seconds} s',
    severity: {
      critical: 'Kritické',
      warning: 'Varování',
      unknown: 'Neznámé'
    }
  },
  explorer: {
    title: 'Průzkumník prostředků',
    root: 'Kořen',
    empty: 'V tomto scope není žádný prostředek',
    previewHint: 'Vyberte objekt pro zobrazení jeho náhledu',
    open: 'Otevřít',

    // Deep-link ?scope= CRUD seznamů (round #109), z průzkumníku (#143).
    openScoped: 'Otevřít seznam v tomto scope',
    kinds: {
      vm: 'VM',
      vmTemplate: 'Šablona VM',
      ct: 'CT',
      ctTemplate: 'Šablona CT',
      app: 'App',
      overlayNetwork: 'Overlay síť',
      networkService: 'Síťová služba',
      fabric: 'Fabric',
      subnet: 'Podsíť',
      storage: 'Pool úložiště',
      disk: 'Disk',
      catalogFile: 'Soubor katalogu',
      ociRegistry: 'Registr OCI',
      ociImage: 'Obraz OCI',
      cephCluster: 'Klastr Ceph',
      backupDestination: 'Cíl záloh',
      user: 'Uživatel',
      group: 'Skupina',
      role: 'Role',
      credential: 'Přihlašovací údaje',
      tag: 'Tag',
      proximityRule: 'Pravidlo proximity'
    }
  },
  tags: {
    title: 'Tagy',
    empty: 'Žádné tagy',
    add: 'Přidat tag',
    remove: 'Odebrat',
    name: 'Tag',
    value: 'Hodnota',
    save: 'Uložit',
    saveError: 'Tagy se nepodařilo uložit',
    loadError: 'Nepodařilo se načíst slovník tagů',
    noVocabulary: 'Pro tento druh prostředku není k dispozici žádný tag',

    // Už nastavený jednohodnotový tag odpovídá 409: nahrazení je vždy
    // explicitní — nikdy implicitní záměna (design, ratifikováno 2026-07-27).
    overwrite: 'Nahradit aktuální hodnotu',

    // Systém > Tagy, plocha slovníku.
    createTitle: 'Vytvořit tag',
    editTitle: 'Upravit tag',
    nameHint: 'Písmena, číslice, tečky, pomlčky a podtržítka — žádné ":" ani "/"; prefix tvirt- je vyhrazen platformě',
    cardinality: 'Kardinalita',
    cardinalitySingle: 'Jedna hodnota',
    cardinalityMultiple: 'Více hodnot',
    cardinalityHint: 'U tagu s jedinou hodnotou se opětovné přiřazení zeptá, zda hodnotu nahradit',
    autoCreate: 'Automatické vytváření hodnot',
    autoCreateOn: 'Při přiřazení',
    autoCreateOff: 'Jen deklarované',
    autoCreateHint: 'Zapnuto: přiřazení nové hodnoty ji vytvoří. Vypnuto: přiřadit lze jen deklarované hodnoty',
    values: 'Hodnoty',
    noValues: 'Žádná deklarovaná hodnota',
    addValue: 'Přidat hodnotu',
    duplicateValue: 'Duplicitní hodnota',
    kinds: 'Druhy prostředků',
    kindsAll: 'Všechny',
    kindsPlaceholder: 'Všechny',
    kindsHint: 'Ponechte prázdné, aby byl povolen každý tagovatelný druh prostředku',
    systemChip: 'Systém',
    deleteCascade: 'Odstranit i přiřazení',
    deleteCascadeHint: 'Tag, který je stále přiřazen nějakému prostředku, je odmítnut: s touto volbou odejdou hodnoty a všechna přiřazení spolu s tagem.'
  },
  scopes: {
    title: 'Scope',
    createTitle: 'Vytvořit scope',
    editTitle: 'Přejmenovat scope',
    path: 'Cesta',
    segment: 'Segment',
    segmentHint: 'Malá písmena, číslice a pomlčky (DNS-1123)',
    parent: 'Nadřazený',
    rootChip: 'Kořen',
    preview: 'Nový scope',
    pickLabel: 'Scope',
    pickHint: 'Kde objekt žije ve stromu klastru — kořen, nebo vDC pod ním.',
    ociCache: 'Mezipaměť OCI (override)',
    appEphemeral: 'Efemérní pool pro App (override)',
    inherit: 'Dědit',
    inheritsFrom: 'Dědí z',
    inheritsCluster: 'Dědí výchozí nastavení klastru',
    inheritsNone: 'Dědí — žádný efektivní pool',
    failoverProtection: 'Ochrana při degradaci klastru',
    networkWeight: 'Síťová váha',
    networkCeil: 'Síťový strop (Mbps)',
    protectionProtected: 'Chráněný',
    protectionExpendable: 'Při degradaci obětovatelný',
    protectionDefault: 'Výchozí nastavení klastru'
  },

  // Systém > Informace (round #124, 2026-07-31): verze platformy ve flotile
  // (nejvýše dvě během upgradu), komponenty podle uzlů, lokálně servírovaný
  // manuál PDF a pohlcená karta licence.
  sysinfo: {
    summary: 'Verze platformy v klastru, komponenty jednotlivých uzlů, administrátorská příručka a licence.',
    platformTitle: 'Platforma TVirt',
    platformSubtitle: 'Verze pozorované na uzlech klastru',
    versionOnNodes: '{version} na {n} uzlech',
    versionOnOneNode: '{version} na 1 uzlu',
    mixedVersions: 'Více než jedna verze platformy v klastru — očekává se jen během probíhajícího upgradu (nejvýše dvě).',
    tooManyVersions: 'Více než dvě verze platformy v klastru — to se neočekává nikdy, ani během upgradu: zkontrolujte uzly níže.',
    unreportedNodes: 'Zatím žádné hlášení verzí od: {nodes}',
    noVersionsYet: 'Žádný uzel zatím nenahlásil své verze.',
    nodesUnavailable: 'Seznam uzlů není s vašimi oprávněními viditelný — verze platformy nelze zobrazit.',
    colNode: 'Uzel',
    manualTitle: 'Administrátorská příručka',
    manualSubtitle: 'Místní kopie, poskytovaná tímto klastrem',
    manualBody: 'Kompletní příručka TVirt v PDF, poskytovaná přímo platformou — dostupná i v air-gapped prostředích.',
    manualLink: 'Administrátorská příručka (PDF)',
    apiExplorerTitle: 'Průzkumník API',
    apiExplorerSubtitle: 'Kontrakt OpenAPI, k procházení',
    apiExplorerBody: 'Úplný kontrakt OpenAPI platformy — každá trasa, schéma a kód odpovědi — k procházení z prohlížeče, servírovaný přes tento uzel.',
    apiExplorerLink: 'Prozkoumat API',
    kubeTitle: 'Kompatibilita s Kubernetes',
    kubeSubtitle: 'kubectl a jeho nástroje před nativním API',
    kubeBody: 'TVirt KubeCompat promítá Pody, Deploymenty, Service, jmenné prostory, uzly a události do dialektu Kubernetes — jen pro čtení, plus mazání Deploymentů. Každé volání prochází nativním API s tvými oprávněními: v kubeconfigu použij app token jako bearer.',
    kubeEndpoint: 'Endpoint pro kubectl',
    kubeStatusActive: 'Aktivní — Kubernetes {version}',
    kubeStatusMissing: 'Na tomto uzlu není nainstalováno (balíček trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Nainstalováno, ale neodpovídá — zkontroluj jednotku trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Kontroluje se…'
  },

  // Licensing (round 2026-07-29): stránka předplatitelské licence klastru.
  licensing: {
    title: 'Licence klastru',
    subtitle: 'Předplatitelská licence — nejvýše jedna na klastr',
    absentTitle: 'Žádná licence není zaregistrována',
    absentBody:
      'Bez platné licence klastr odmítá spouštět nové virtuální stroje (zapnuté VM zůstávají zapnuté). Zaregistrujte produktový klíč, který jste obdrželi s předplatným.',
    registerButton: 'Zaregistrovat licenci',
    removeButton: 'Odebrat licenci',
    state: {
      ok: 'Platná',
      limitExceeded: 'Limit překročen',
      expired: 'Vypršelá'
    },
    productKeyLabel: 'Produktový klíč',
    basisLabel: 'Základ limitu',
    basis: {
      concurrentVms: 'Současně zapnuté VM',
      physicalCores: 'Fyzická jádra (celkem za klastr)'
    },
    limitLabel: 'Limit',
    usageLabel: 'Aktuální využití',
    usageOf: '{used} z {limit}',
    usagePartial: 'částečný součet — uzlů bez pozorované topologie CPU: {n}',
    usageUnknown: 'momentálně nepozorovatelné',
    expiresLabel: 'Konec platnosti',
    neverExpires: 'nikdy',
    registeredLabel: 'Zaregistrována',
    gateNote:
      'S licencí chybějící, vypršelou nebo nad limitem klastr odmítá spouštět NOVÉ virtuální stroje. Zapnuté VM zůstávají zapnuté a restartů HA se to nedotýká.',
    devStage:
      'Vývojová fáze: produktový klíč je přijat tak, jak je, spolu s limity deklarovanými zde; validace podepsaným klíčem dorazí v budoucí verzi.',
    dialogTitle: 'Zaregistrovat licenci',
    dialogExpiresHelp: 'Prázdné = licence nikdy nevyprší',
    dialogSubmit: 'Zaregistrovat',
    dialogError: 'Licenci se nepodařilo zaregistrovat.',
    removeTitle: 'Odebrat licenci',
    removeBody:
      'Klastr zůstane BEZ LICENCE: nové virtuální stroje odmítnou startovat, dokud nějakou nezaregistrujete. Zapnuté VM zůstávají zapnuté.',
    removeConfirm: 'Odebrat',
    removeError: 'Licenci se nepodařilo odebrat.'
  },
  rbac: {
    tabRoles: 'Role',
    tabGrants: 'Delegace',
    rolesTitle: 'Role',
    createRoleTitle: 'Vytvořit roli',
    editRoleTitle: 'Upravit roli',
    nameHint: 'Malá písmena, číslice a pomlčky; prefix tvirt- je vyhrazen',
    systemChip: 'Systém',
    permissions: 'Oprávnění',
    permissionsPlaceholder: 'Přidat oprávnění…',
    includedRoles: 'Zahrnuté role',
    includedRolesPlaceholder: 'Přidat roli…',
    grantsTitle: 'Delegace',
    createGrantTitle: 'Vytvořit delegaci',
    principal: 'Principal',
    principalKind: 'Druh principalu',
    principalUser: 'Uživatel',
    principalGroup: 'Skupina',
    role: 'Role',
    grantRight: 'Delegace',
    grantRightChip: 'Může delegovat',
    grantRightLabel: 'S právem delegovat (příjemce může tuto roli delegovat dál)',
    effective: 'Účinná',
    notEffective: 'Neúčinná',
    createdAt: 'Vytvořena',
    scopeHint: '/path přesně, /path/* rekurzivně — delegace se kotví k připojenému kořeni (/* delegovat nelze)'
  },
  groups: {
    title: 'Skupiny',
    createTitle: 'Vytvořit skupinu',
    nameHint: 'Malá písmena, číslice a pomlčky; jedinečné v rámci scope',
    members: 'Členové',
    membersTitle: 'Členové',
    membersPlaceholder: 'Přidat uživatele…',
    noMembers: 'Žádní členové',
    realmMappings: 'Mapování realmů',
    realmMappingsTitle: 'Mapování realmů',
    realmMappingsHint:
      'Čemu tato skupina odpovídá v jednotlivých externích realmech. Členství se čte z adresáře při přihlášení: adresářová skupina, kterou sem nikdo nenamapuje, se ignoruje, a vnořování se neřeší — je třeba ho zploštit na straně adresáře.',
    realm: 'Realm',
    externalGroup: 'Externí skupina',
    addRealmMapping: 'Přidat mapování',
    removeRealmMapping: 'Odebrat mapování',
    noRealmMappings: 'Žádné mapování realmů',

    // Sekční dialog vytvoření (round realm-wizard, 2026-08-03): Obecné plus
    // plocha mapování s externími realmy, s výmluvným prázdným stavem.
    sectionGeneral: 'Obecné',
    mappingsNoRealms: 'Žádný externí realm zatím není nakonfigurován — plocha mapování se odemkne, jakmile nějaký realm existuje.',
    mappingsNoRealmsLink: 'Otevřít kartu Realmy a SSO',

    // Povinnost MFA uložená skupinou (round #178 polovina B): čisté OR —
    // skupina může povinnost jen PŘIDAT, nikdy sejmout.
    mfaRequired: 'Povinnost MFA',
    mfaRequiredChip: 'Vynucuje MFA',
    mfaNotRequiredChip: 'Žádná povinnost',
    mfaRequiredHint:
      'Čisté OR: skupina může svým členům PŘIDAT povinnost druhého faktoru — i externím identitám, přes svá mapování realmů — nikdy ji sejmout. Platí od příštího přihlášení: otevřené relace se nezavírají.'
  },
  users: {
    title: 'Uživatelé',
    createTitle: 'Vytvořit uživatele',
    editTitle: 'Upravit uživatele',
    username: 'Uživatelské jméno',
    usernameHint: 'Malá písmena, číslice, tečky a pomlčky',
    displayName: 'Zobrazované jméno',
    enabled: 'Povolen',
    state: 'Stav',
    enabledChip: 'Povolen',
    disabledChip: 'Zakázán',
    lockedChip: 'Uzamčen',
    password: 'Heslo',
    passwordSetChip: 'Nastaveno',
    mustChangeChip: 'Nutno změnit',
    initialPassword: 'Počáteční heslo',
    initialPasswordHint: 'Uživatel si ho bude muset změnit při prvním přihlášení',
    lastLogin: 'Poslední přihlášení',
    neverLoggedIn: 'Nikdy se nepřihlásil',
    setPasswordTitle: 'Nastavit heslo',
    setPasswordHint: 'Administrativní nahrazení — vyžaduje vaše heslo (režim sudo) a přinutí uživatele změnit si ho při příštím přihlášení.',
    operatorPassword: 'Vaše heslo',
    unlock: 'Odemknout účet',
    revokeTitle: 'Odvolat relace',
    revokeBody: 'Všechny aktivní relace tohoto uživatele budou okamžitě ukončeny.',
    revokeIncludeTokens: 'Odvolat také app tokeny',
    revokeConfirm: 'Odvolat',

    // Standardní dialog (round #156): kompletní podrobnosti, karty účet/zabezpečení.
    tabAccount: 'Účet',
    tabSecurity: 'Zabezpečení',
    usernameImmutableHint: 'Uživatelské jméno je identitou účtu — pevně dané při vytvoření',
    groups: 'Skupiny',
    noGroups: 'Žádné skupiny',
    mustChangePassword: 'Povinná změna hesla',
    failedAttempts: 'Neúspěšné pokusy o přihlášení',
    lockedUntil: 'Uzamčen do',

    // Karty identit (2026-08-03): Systém > Uživatelé se stala sekcí s kartami
    // podle vzoru /system/rbac — uživatelé, skupiny, externí realmy.
    tabUsers: 'Uživatelé',
    tabGroups: 'Skupiny',
    tabRealms: 'Realmy a SSO',
    tabMfa: 'MFA',

    // Karta MFA (task #178): pohled na druhý faktor. Polovina A — tabulka po
    // uživatelích nad users.yaml; polovina B (round contract, ratifikace
    // 2026-08-04) — efektivní verdikt s původem, externí enrollmenty se
    // stavem sirotka a skupiny vynucující povinnost.
    mfa: {
      title: 'Druhý faktor (MFA)',
      methodsTitle: 'Dostupné metody',
      methodsSubtitle: 'Co tato instalace umí ověřit jako druhý faktor',
      methodsError: 'Nepodařilo se načíst registr metod',
      builtinChip: 'Vestavěná',
      enrollableChip: 'Enrollment v TVirt',
      delegatedChip: 'Spravováno externě',
      state: 'Stav',
      stateActive: 'Aktivní',
      statePending: 'Čeká na enrollment',
      stateNone: 'Bez enrollmentu',
      required: 'Povinnost MFA',
      requiredChip: 'Povinné',
      notRequiredChip: 'Nepovinné',
      enrolledAt: 'Enrollment ze dne',
      enrolledMethods: 'Metody s enrollmentem',
      noMethods: 'Žádný enrollment',
      codesRemaining: 'Zbývající kódy pro obnovení',
      resetTitle: 'Resetovat druhý faktor',
      resetHint:
        'Enrollment a všechny kódy pro obnovení se vynulují: při příštím přihlášení uživatel projde enrollmentem znovu od začátku. Povinnost MFA zůstává, jak je — správce tajný klíč nikdy nenastavuje, pouze ho nuluje.',
      resetConfirm: 'Resetovat',
      resetError: 'Druhý faktor se nepodařilo resetovat',
      empty: 'Zatím žádný spravovaný uživatel — účty se tu objeví, jakmile existují, každý se svým stavem druhého faktoru.',

      // Polovina B (round #178): původ efektivního verdiktu, externí
      // enrollmenty se stavem sirotka, skupiny vynucující povinnost.
      viaSelf: 'Osobní',
      viaSelfHint: 'Vlastní příspěvek účtu (jeho příznak) — jediná část, kterou tužka upravuje.',
      viaGroupHint: 'Povinnost zděděná z této skupiny: odebrání osobního příznaku uživatele neosvobodí — zasahuje se na skupině, na kartě Skupiny.',
      subject: 'Identita',
      lastSeenAt: 'Poslední potvrzení',
      enrollmentPending: 'Čeká',
      orphanChip: 'Osiřelý',
      orphanDirectoryMiss: 'Identita už není v adresáři',
      orphanRealmRemoved: 'Realm byl z TVirt odebrán',
      orphanedAt: 'Osiřelý od',
      directoryUuid: 'UUID v adresáři',
      externalTitle: 'Externí enrollmenty',
      externalEmpty: 'Zatím žádný externí enrollment — vzniká při prvním přihlášení adresářové identity s povinností MFA.',
      orphanHelp:
        'Osiřelý enrollment se nikdy nemaže sám: je to bezpečnostní materiál — zůstává pro audit, a pokud se identita v adresáři znovu objeví, najde svůj faktor zpět. Jediným východiskem je administrativní reset.',
      visibilityHint: 'Externí enrollmenty sídlí v kořeni klastru: vidí je jen ten, kdo má user.read nad celým stromem.',
      orphanResetHint:
        'Osiřelý řádek se odstraní definitivně: už si ho nikdo nenárokuje. Pokud se identita do adresáře někdy vrátí, projde enrollmentem znovu od začátku.',
      enforcingTitle: 'Skupiny vynucující MFA',
      enforcingSubtitle:
        'Kotvou povinnosti pro externí identity je skupina: její mapování realmů říkají, na kterou populaci adresáře dosahuje. Externí enrollment vzniká při prvním přihlášení uživatele s povinností.',
      enforcingEmpty: 'Žádná skupina MFA nevynucuje — povinnost se zapíná na skupině, z karty Skupiny.',
      enforcingError: 'Nepodařilo se načíst skupiny vynucující MFA'
    }
  },
  realms: {
    title: 'Autentizační realmy',
    createTitle: 'Vytvořit realm',
    editTitle: 'Upravit realm',
    name: 'Realm',
    nameHint: 'Doména, kterou uživatelé píší za @ (example.com) — po vytvoření neměnná',
    nameImmutableHint: 'Jméno realmu je otištěno v každé relaci a v každém řádku auditu, který ho kdy jmenoval — přejmenování by přepsalo historii',
    kind: 'Druh',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC a SAML dorazí v příštích roundech — dnes je realm adresářem LDAPv3',

    // Semi-průvodce vytvoření (round realm-wizard, 2026-08-03): karty druhů
    // v kroku 1 — ldap živý, oidc/saml jako roadmap karty (nikdy formulář
    // bez backendu za ním).
    kindCategory: 'Druh realmu',
    kindSelectHint: 'Vyberte druh adresáře, vůči kterému bude tento realm autentizovat.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Username a heslo ověřené bindem na adresáři LDAPv3 — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on z prohlížeče delegované na identity provider OpenID Connect — dorazí v příštích roundech.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Podnikové single sign-on prostřednictvím asercí SAML 2.0 — dorazí v příštích roundech.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Povolen',
    urls: 'Servery adresáře',
    urlsHint: 'Jeden URL ldap:// nebo ldaps:// na řádek (1–8), zkoušené v pořadí — failover, nikdy balancování',
    startTls: 'StartTLS',
    verifyCertificate: 'Ověřovat certifikát',
    cleartextWarning: 'Bez ldaps:// nebo StartTLS prochází heslo bindu sítí v čitelné podobě — přijatelné v laboratoři, nikdy v produkci.',
    noVerifyWarning: 'Neověřená relace TLS neautentizuje nikoho: vypněte ověřování jen vůči adresáři, který nemůžete opravit.',
    caCertificate: 'Certifikát CA (PEM)',
    caCertificateHint: 'Volitelný CA bundle připnutý pro TLS/StartTLS handshake tohoto realmu; prázdné ho odstraní',
    caCertificatePinned: 'Připnutý',
    connectTimeout: 'Timeout (sekundy)',
    connectTimeoutHint: 'Lhůta připojení a požadavku pro každý URL (1–60); po vypršení se zkusí další URL',
    bindDn: 'Bind DN',
    bindDnHint: 'Service account, který provádí vyhledání uživatele; prázdné = anonymní search bind (AD ho odmítá)',
    anonymousBind: 'Anonymní search bind',
    bindCredential: 'Heslo bindu (keystore)',
    bindCredentialHint: 'Položka usernamePassword v keystore s heslem bindu — tajemství nikdy nežije na realmu',
    bindCredentialNone: 'Žádné (anonymní bind)',
    bindCredentialEmpty: 'V keystore není žádná položka usernamePassword — vytvořte ji v Systém > Přihlašovací údaje pro heslo bindu.',
    baseDn: 'Base DN',
    baseDnHint: 'Podstrom, od kterého začíná vyhledání uživatele (DC=example,DC=com)',
    userFilter: 'Uživatelský filtr',
    userFilterHint: '%u se nahrazuje lokální částí loginu s escapováním dle RFC 4515; ne-AD adresáře typicky chtějí (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'Atribut memberOf',
    memberOfAttributeHint: 'Čte se jen jednou, při přihlášení — nenamapované skupiny se ignorují, vnořování se neřeší',
    uuidAttribute: 'Atribut UUID',
    uuidAttributeHint: 'Neměnný UUID v rámci realmu (objectGUID na AD, entryUUID na OpenLDAP) — otiskne se do auditu vedle uživatel@realm',
    displayNameAttribute: 'Atribut zobrazovaného jména',
    displayNameAttributeHint: 'Používá se k pozdravení uživatele; jinak se použije přihlašovací jméno',
    sudoHint: 'Zápisy na realmech jsou chráněné režimem sudo: realm jsou vstupní dveře do platformy',
    deleteBody: 'Mapování skupin realmu odcházejí s ním; relace, které autentizoval, zůstávají živé až do vypršení — smazaný realm prostě už nikoho nového nevpustí.',
    tabConnection: 'Připojení',
    tabDirectory: 'Adresář',
    testTitle: 'Test připojení',
    testHint: 'Sonda konfigurace, nikdy autentizace: připojí se, provede bind jako service account a — se zadaným uživatelským jménem — spustí uživatelský filtr.',
    testUsername: 'Uživatelské jméno (volitelné)',
    testUsernameHint: 'Lokální část, nad kterou se spustí uživatelský filtr — 1 shoda je zdravá odpověď',
    testRun: 'Spustit test',
    testError: 'Sondu se nepodařilo spustit',
    testReachable: 'Adresář dostupný, servisní bind přijat',
    testUnreachable: 'Adresář NENÍ dostupný',
    matchedOne: 'Uživatelský filtr našel přesně 1 položku — zdravá odpověď.',
    matchedNone: 'Uživatelský filtr nenašel žádnou položku: filtr nebo base DN je špatně.',
    matchedMany: 'Uživatelský filtr našel více položek (celkem {count}): není selektivní a přihlášení by byla nejednoznačná (odmítnuta).',
    mappingsPointer: 'Čemu externí skupina odpovídá, je vlastnost skupiny TVirt (její mapování realmů): bod pravdy žije na kartě Skupiny.',
    mappingsPointerLink: 'Otevřít kartu Skupiny',
    rootHomeHint: 'Identity externího realmu žijí v kořeni klastru, nikdy ve vDC: oprávnění se přidělují tam, kde jsou potřeba, pomocí delegací — na skupině, nebo přímo na uživateli, přesně jako u nativních.'
  },
  credentials: {
    title: 'Přihlašovací údaje',
    createTitle: 'Vytvořit přihlašovací údaje',
    editTitle: 'Upravit přihlašovací údaje',
    kind: 'Druh',
    kindUsernamePassword: 'Username a heslo',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (identita Ceph)',
    kindHintUsernamePassword: 'Neměnné. Pro úložiště CIFS/SMB — účet mountu, jehož tajemství worker používá v okamžiku mountu.',
    kindHintIscsiChap: 'Neměnné. Pro autentizaci CHAP iSCSI — username = jméno CHAP, secret = tajemství CHAP.',
    kindHintNvmeDhchap: 'Neměnné. Pro DH-HMAC-CHAP u NVMe over Fabrics — secret = blob DHHC-1:xx:…; username je jen popisek.',
    kindHintCephx: 'Neměnné. Pro klienty Ceph — username = jméno klienta (client.…), secret = klíč v base64.',
    kindImmutableHint: 'Druh je po vytvoření neměnný — jeho změna znamená nové přihlašovací údaje.',
    username: 'Uživatelské jméno',
    usernameChap: 'Jméno CHAP',
    usernameNvme: 'Popisek',
    usernameCephx: 'Jméno klienta',
    usernameHint: 'Volitelný účet, ke kterému tajemství patří',
    usernameHintChap: 'Jméno CHAP, kterým se initiator autentizuje',
    usernameHintNvme: 'Transport ho nepoužívá — volný popisek pro vaše poznámky',
    usernameHintCephx: 'Jméno klienta cephx — prefix client. je tolerován',
    secret: 'Tajemství',
    secretHint: 'Pouze pro zápis: používají ho konzumenti, už nikdy se nezobrazí.',
    secretHintNvmeDhchap: 'Pouze pro zápis: tajemství DH-HMAC-CHAP hostitele v kanonické podobě DHHC-1:xx:… — používají ho konzumenti, už nikdy se nezobrazí.',
    secretHintCephx: 'Pouze pro zápis: klíč cephx v base64 — používají ho konzumenti, už nikdy se nezobrazí.',
    secretEditHint: 'Ponechte prázdné pro zachování aktuálního tajemství — vyplněním provedete rotaci.',
    createdAt: 'Vytvořeno',
    inUseError: "Na '{name}' odkazuje konfigurace některého úložiště — nejprve je tam odpojte.",
    nameHint: 'Malá písmena, číslice a pomlčky (DNS-1123); jedinečné v rámci scope',

    // Dialog jen pro rotaci (round #156): tajemství nikdy nemá inline tužku.
    rotateTitle: 'Rotovat tajemství',
    rotateHint: 'Pouze pro zápis: nové tajemství nahradí to uložené — konzumenti si ho převezmou při svém příštím mountu.',

    // Round #159 (PKI): karty Certifikáty a CA.
    tabSecrets: 'Tajemství',
    tabCertificates: 'Certifikáty',
    tabAuthorities: 'Certifikační autority',
    certificatesTitle: 'Certifikáty',
    authoritiesTitle: 'Certifikační autority',
    caCreateTitle: 'Nová CA',
    certCreateTitle: 'Nový certifikát',
    caMode: 'Zdroj',
    caModeGenerate: 'Vygenerovat pomocí TVirt',
    caModeImport: 'Importovat (klíč + certifikát)',
    certMode: 'Zdroj',
    certModeIssue: 'Vystavit z CA v keystore',
    certModeImport: 'Importovat (klíč + certifikát)',
    issuingCa: 'Vystavující CA',
    issuingCaHint: 'Certifikát vzniká ve scope dané CA, se zaznamenaným parentem',
    noCasHint: 'V keystore není žádná CA — nejprve nějakou vygenerujte nebo importujte na kartě CA',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'Subject CA: písmena, číslice, mezera, tečka, podtržítko, pomlčka',
    commonNameCertHint: 'OpenVPN identifikuje klienty podle CN — udržujte ho jedinečný v rámci CA',
    days: 'Platnost (dny)',
    daysCaHint: '1–7300 dní; výchozí je 3650 (10 let)',
    daysCertHint: '1–3650 dní; výchozí je 365',
    keyType: 'Typ klíče',
    keyTypeHint: 'EC P-256 je výchozí; RSA pro legacy konzumenty',
    usage: 'Použití',
    usageClient: 'Klient (clientAuth)',
    usageServer: 'Server (serverAuth)',
    usageHint: 'Extended key usage, pro které se certifikát vystavuje',
    san: 'Alternativní jména (SAN)',
    sanHint: 'Oddělené čárkami; IP literály se stanou položkami IP:, zbytek DNS:',
    keyPem: 'Soukromý klíč (PEM)',
    keyPemHint: 'Pouze pro zápis: uložen v keystore, už nikdy se nezobrazí',
    certPem: 'Certifikát (PEM)',
    certPemHint: 'Veřejný certifikát, který se páruje s klíčem',
    certPemCaHint: 'Certifikát CA, který se páruje s klíčem (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Vystavitel',
    parentCa: 'Vystavující CA',
    parentCaImported: 'Importován — vystaven mimo TVirt',
    serial: 'Sériové číslo',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Platný od',
    validUntil: 'Platný do',
    expiry: 'Konec platnosti',
    expired: 'Vypršelý',
    expiresInDays: 'Vyprší za {days} d',
    revoked: 'Odvolán',
    revokedAtLabel: 'Odvolán dne',
    revokeTitle: 'Odvolat certifikát',
    revokeAction: 'Odvolat',
    revokeWarning: 'Odvolání je konečné: sériové číslo vstoupí do CRL vystavující CA a každý konzument odmítající odvolané certifikáty (OpenVPN především) tento certifikát odmítne. Žádné un-revoke neexistuje.',
    exportPem: 'Exportovat PEM',
    exportChain: 'Exportovat bundle řetězu',
    exportCrl: 'Exportovat CRL',
    materialImmutableHint: 'Materiál X.509 je neměnný — místo úprav znovu vystavte nebo znovu importujte',
    caInUseError: "'{name}' má ještě živé vystavené certifikáty (nebo na ni odkazuje úložiště) — nejprve je odvolejte nebo smažte."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Umístění, dostupnost a afinita — kde běží VM klastru a zda mají být zapnuté',
    loadError: 'Panel Proximity potřebuje store klastru — stav flotily je teď nedostupný',
    config: {
      title: 'Konfigurace',
      subtitle: 'Politika umísťování pro celý klastr',
      save: 'Uložit',
      saveError: 'Konfigurace byla odmítnuta',
      strategy: 'Strategie výběru',
      strategy_leastUsedResources: 'Nejméně využitých prostředků',
      strategy_leastVms: 'Nejméně VM',
      strategy_random: 'Náhodně',
      strategyLeastUsedResourcesHint: 'Mezi platnými kandidáty uzel s největší zbývající použitelnou RAM (pozorovaný celek − rezerva hostitele − zapnuté VM), závazek vCPU jako rozstřel. Deterministické při shodných datech.',
      strategyLeastVmsHint: 'Mezi platnými kandidáty uzel s nejméně zapnutými VM; remízy se řeší podle jména uzlu. Deterministické při shodných datech.',
      strategyRandomHint: 'Rovnoměrně náhodně mezi platnými kandidáty.',
      liveness: 'Práh živosti uzlů (sekundy)',
      livenessHint: 'Člen mlčící déle než práh je nedostupný: vyloučen z umísťování a — pokud není v údržbě — považován deciderem HA za mrtvého; ten provede jeho fencing a jeho HA VM restartuje jinde.',
      decider: 'Decider HA',
      deciderNone: 'zatím nezvolen'
    },
    nodesTitle: 'Uzly',
    nodesSubtitle: 'Živost a empirická kapacita — použitelná RAM = celkem − základ − vázáno',
    nodeCol: 'Uzel',
    stateCol: 'Stav',
    ramCol: 'RAM (celkem − základ − vázáno)',
    usableCol: 'Použitelná',
    vmsCol: 'Zátěž',
    neverSeen: 'nikdy neviděn',
    freshChip: 'dostupný',
    staleChip: 'nedostupný',
    attestedChip: 'prohlášen za vypnutý',
    ramFormula: 'celkem − základ − vázáno',
    haTitle: 'Vysoká dostupnost',
    haSubtitle: 'VM s příznakem HA jsou "vždy zapnuté": TVirt je restartuje po každém nevyžádaném zastavení — stejný uzel s backoffem, jiný uzel, když ten jejich zemře (jen sdílené úložiště).',
    haNone: 'Žádná VM zatím nemá příznak HA — povolte ho zde, nebo v detailu VM.',
    haVmCol: 'Virtuální stroj',
    haStateCol: 'Stav',
    haRestartsCol: 'Restarty HA',
    haLastEventCol: 'Poslední událost',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'Změna HA byla odmítnuta',
    rules: {
      title: 'Pravidla afinity',
      createTitle: 'Nové pravidlo proximity',
      editTitle: 'Upravit pravidlo',
      nameHint: 'Malá písmena, číslice a pomlčky (DNS label)',
      vms: 'Virtuální stroje',
      vmsHint: 'Alespoň dvě VM — pravidlo váže, kde běží jedna vůči druhé',
      type: 'Typ',
      affinity: 'Afinita (spolu)',
      antiAffinity: 'Anti-afinita (odděleně)',
      typeAffinityHint: 'VM mají běžet na STEJNÉM uzlu.',
      typeAntiAffinityHint: 'VM mají běžet na RŮZNÝCH uzlech — klasická dvojice HA.',
      mode: 'Režim',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Porušení odmítnou operaci (spuštění, migrace, failover) s výmluvnou chybou.',
      modeSoftHint: 'Preference, nikdy blokující: umístění v rozporu pokračuje s viditelným varováním.',
      satisfied: 'Umístění',
      satisfiedYes: 'dodrženo',
      satisfiedNo: 'porušeno',

      // Standardní dialog (round #156): porušení mají vlastní řádek, ne tooltip.
      violations: 'Porušení',
      noViolations: 'Žádná'
    },
    events: {
      title: 'Události HA',
      subtitle: 'Deník dostupnosti — restarty, fencing, failovery a poctivá přeskočení',
      none: 'Zatím nic.',
      when: 'Kdy',
      kind: 'Událost',
      target: 'Objekt',
      detail: 'Detail',
      kindRestarted: 'restart HA',
      kindGaveUp: 'vzdáno (crash loop)',
      kindNodeAttested: 'fencing uzlu',
      kindFailedOver: 'failover',
      kindNoCandidate: 'žádný kandidát',
      kindStorageLocalSkip: 'přeskočeno (lokální úložiště)',
      kindZombieFenced: 'zombie ukončen'
    }
  }
}
